export default __webpack_public_path__ + "images/checkbox-blau-active.svg";